import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import AppRouter from './AppRouter'
import { useConnectionStatus } from './hooks/useConnectionStatus'

const App: React.FC = () => {
  useConnectionStatus()

  return (
    <HelmetProvider>
      <div className='min-h-screen flex flex-col justify-center max-w-full overflow-hidden'>
        <div className=''>
          <AppRouter />
        </div>
      </div>
    </HelmetProvider>
  )
}

export default App
